import { render, staticRenderFns } from "./FormWarehouseUsers.vue?vue&type=template&id=d0afb20a&scoped=true"
import script from "./FormWarehouseUsers.vue?vue&type=script&lang=js"
export * from "./FormWarehouseUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0afb20a",
  null
  
)

export default component.exports